import { jsx as t } from "react/jsx-runtime";
import l from "./index.es5624.js";
import { ReportDailyFailedIllustration as m } from "./index.es474.js";
import { ChainIllustration as n } from "./index.es483.js";
import { DownloadAlertIllustration as a } from "./index.es482.js";
import { SentEmailIllustration as s } from "./index.es481.js";
import { PinAlertIllustration as e } from "./index.es480.js";
import { PinSuccessIllustration as p } from "./index.es479.js";
import { GetDemoIllustration as u } from "./index.es478.js";
import { ExpireIllustrationNoBackground as f } from "./index.es477.js";
import { ExpireIllustration as I } from "./index.es476.js";
import { BellIllustration as c } from "./index.es475.js";
import { ReportDailyIllustration as d } from "./index.es473.js";
import { EmailIllustration as D } from "./index.es472.js";
import { RestartIllustration as x } from "./index.es471.js";
import { LockIllustration as E } from "./index.es470.js";
import { UpsellIllustration as y } from "./index.es469.js";
import { DeleteIllustration as B } from "./index.es468.js";
const C = {
  DeleteIllustration: B,
  UpsellIllustration: y,
  LockIllustration: E,
  RestartIllustration: x,
  EmailIllustration: D,
  ReportDailyIllustration: d,
  BellIllustration: c,
  ExpireIllustration: I,
  ExpireIllustrationNoBackground: f,
  GetDemoIllustration: u,
  PinSuccessIllustration: p,
  PinAlertIllustration: e,
  SentEmailIllustration: s,
  DownloadAlertIllustration: a,
  ChainIllustration: n,
  ReportDailyFailedIllustration: m
}, H = ({
  illustration: o,
  testId: r
}) => {
  const i = C[o];
  return /* @__PURE__ */ t("div", { className: l.iconContainer, "data-testid": r, children: /* @__PURE__ */ t(i, {}) });
};
export {
  H as ConfirmationDialogBoxIllustration,
  C as confirmationIllustrationIcons
};
//# sourceMappingURL=index.es786.js.map
